import React from "react";
import { connect } from "react-redux";
import Card from "components/card";
import { MapPin } from "lucide-react";
import CrudOption from "components/dropdown/crudoption";
import {
    doTrainingClassParticipantDelete
} from "../../../../../redux/trainingclass/trainingClassState";
import { Progress } from "antd";
import ResultModal from "./ParticipantModuleResultModal";

const TrainingModuleParticipantCard = ({
    recordData,
    classeId,
    doDelete,
}) => {
    const participant = recordData?.participant || recordData;
    const canDelete = (participant?.participant_progress || 0) === 0;

    return (
        <Card className="bg-white text-slate-900 flex flex-col gap-4 sm:gap-6 rounded-2xl border border-slate-200">
            <div className="relative p-4 sm:p-6">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-6 items-start">
                    <div className="md:col-span-6 flex items-start gap-3 min-w-0 pr-20">
                        <span className="relative flex w-10 h-10 sm:w-12 sm:h-12 shrink-0 overflow-hidden rounded-full border-2 border-white shadow-md">
                            <span className="flex w-full h-full items-center justify-center rounded-full bg-emerald-100 text-emerald-700 font-medium">
                                {participant?.participant_initial}
                            </span>
                        </span>

                        <div className="flex-1 min-w-0">
                            <div className="flex items-center gap-2 flex-wrap">
                                <h4 className="font-semibold line-clamp-2">
                                    {participant?.participant_name}
                                </h4>
                                <span className="inline-flex items-center justify-center rounded-xl border px-2 py-0.5 font-medium text-[10px] truncate">
                                    {participant?.participant_emp_code}
                                </span>
                            </div>
                            <p className="text-[13px] text-slate-700 truncate">
                                {participant?.participant_emp_title} • {participant?.participant_emp_department} 
                            </p>
                            <div className="flex items-center gap-1 flex-wrap">
                                <MapPin className="w-3 h-3 text-slate-700" />
                                <span className="text-[12px] text-slate-700 truncate">
                                    {participant?.participant_country}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="md:col-span-4">
                        <p className="text-[11px] text-slate-700 mb-1">Progress</p>
                        <div className="flex items-center gap-3">
                            <div className="flex-1">
                                <Progress 
                                    percent={participant?.participant_progress || 0} 
                                    showInfo={false}
                                    strokeWidth={8}   
                                    strokeColor="#10B981"                  
                                    trailColor="rgba(16, 185, 129, 0.2)"
                                />
                            </div>
                            <span className="text-lg font-semibold text-purple-600 whitespace-nowrap">
                                {participant?.participant_progress}%
                            </span>
                        </div>
                    </div>

                    <div className="absolute top-6 right-6 z-10">
                        <div className="text-xs rounded-lg border px-2 py-1">
                            <CrudOption 
                                baseRoute={`/console/training-module-classes/${classeId}/training-class-participants`} 
                                recordId={recordData?.tcp_user_id} 
                                allowView={false}
                                allowEdit={false}
                                allowDetail={true}
                                allowDelete={canDelete}
                                detailMode="modal"
                                modalWidth={1000}
                                detailHandler={(recordId) => (
                                    <ResultModal
                                        recordId={recordId}
                                        classeId={classeId}
                                    />
                                )}
                                deleteHandler={() => doDelete({
                                    tcp_user_id: recordData?.tcp_user_id,
                                    tcp_id: recordData?.tcp_id,
                                })} 
                            />
                        </div>
                        
                    </div>
                </div>
            </div>
        </Card>
    );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
    doDelete: (id) => dispatch(doTrainingClassParticipantDelete(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TrainingModuleParticipantCard);
